import React, { useState } from 'react'
import { FaGift } from 'react-icons/fa'
import { NextButton, BackButton } from '../shared/Buttons'
import { Theme } from '../../../lib/theme'

interface ReferralCodeFormProps {
  onContinue: (data: { referralCode: string }) => void
  onBack: () => void
  initialCode?: string
  isNextLoading: boolean
}

const ReferralCodeForm: React.FC<ReferralCodeFormProps> = ({
  onContinue,
  onBack,
  initialCode = '',
  isNextLoading,
}) => {
  const [referralCode, setReferralCode] = useState(initialCode)

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setReferralCode(e.target.value)
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    onContinue({ referralCode })
  }

  return (
    <div
      className="lg:p-0 p-2 w-full mt-[4rem] xl:mt-[2rem] 2xl:mt-[3rem] md:h-[90%] md:w-[80%] md:shadow-lg md:rounded-3xl md:flex md:flex-col md:items-center md:justify-between md:p-4"
      style={{ backgroundColor: Theme.colors.background }}
    >
      {/* Heading Section */}
      <div className="flex flex-col items-center gap-1 p-2 lg:p-0">
        <FaGift
          className="text-6xl lg:text-4xl xl:text-6xl mb-2"
          style={{ color: Theme.colors.primary }}
        />
        <h1
          className="text-2xl font-bold mb-1"
          style={{ color: Theme.colors.text.strong }}
        >
          Referral Code
        </h1>
        <p style={{ color: Theme.colors.text.weak }}>
          Enter your referral code to get benefits
        </p>
      </div>

      {/* Input Section */}
      <form
        onSubmit={handleSubmit}
        className="w-full max-w-sm mx-auto flex-grow flex flex-col justify-center"
      >
        <div className="w-full">
          <label
            htmlFor="referralCode"
            className="mb-3 font-semibold block text-left"
            style={{ color: Theme.colors.text.default }}
          >
            Referral Code (optional)
          </label>
          <input
            type="text"
            id="referralCode"
            placeholder="Enter referral code"
            className="mb-7 w-full rounded-xl border outline-none"
            style={{
              padding: '1rem',
              borderColor: Theme.colors.stroke.weak,
              color: Theme.colors.text.default,
              backgroundColor: Theme.colors.background,
              caretColor: Theme.colors.primary,
            }}
            value={referralCode}
            onChange={handleChange}
          />
        </div>
      </form>

      {/* Buttons */}
      <div className="lg:w-[40%] flex flex-col items-center p-2 mt-auto lg:pb-20 gap-2">
        {isNextLoading ? (
          <div
            className="w-10 h-10 border-4 rounded-full animate-spin"
            style={{
              borderColor: Theme.colors.stroke.weak,
              borderTopColor: Theme.colors.button.primary,
            }}
          ></div>
        ) : referralCode.trim().length > 0 ? (
          <NextButton
            text="Continue"
            onClick={handleSubmit}
          />
        ) : (
          <NextButton
            text="Skip"
            onClick={() => onContinue({ referralCode: '' })}
          />
        )}
        <BackButton onClick={onBack} />
      </div>
    </div>
  )
}

export default ReferralCodeForm
